function shortenFileName(name: string, maxLength: number = 16) {
    const [, filename, ext] = name.match(/^(.*)\.((?:.(?!\\))+)$/i);
    const fragmentLength = Math.floor(maxLength / 3);
    return `${filename.length > maxLength ? filename.substr(0, fragmentLength) + '&hellip;' + filename.substr(-fragmentLength) : filename}.${ext}`;
}

document.querySelectorAll('[data-file-input]').forEach((el: HTMLInputElement) => {
    const target = document.querySelectorAll(el.getAttribute('data-file-input'));
    const maxLength = el.hasAttribute('data-maxlength') ? parseInt(el.getAttribute('data-maxlength')) : null;

    el.addEventListener('change', () => {
        target.forEach(t => {
            if (el.files && el.files[0]) {
                t.innerHTML = shortenFileName(el.files[0].name, maxLength);
            } else {
                t.innerHTML = '';
            }
        });
    });
});
